import apiClient from "../../app/apiClient";

export function mediaUrl(image) {
  const value = typeof image === "string" ? image : image?.url || image?.imageUrl || image?.image_url || image?.mediaUrl || image?.image;
  return typeof value === "string" && /^(https?:\/\/|\/)/i.test(value) ? value : "";
}

export function getCoverImageId(project) {
  return project.coverImageId !== undefined ? project.coverImageId : project.cover_image_id ?? null;
}

export function normalizeMedia(raw) {
  const coverImageId = getCoverImageId(raw);
  const images = (Array.isArray(raw.images) ? raw.images : []).map((item, index) => ({
    ...(typeof item === "object" && item ? item : {}),
    id: typeof item === "object" && item ? item.id : null,
    imageUrl: mediaUrl(item),
    createdAt: item?.createdAt ?? item?.created_at ?? null,
    title: item?.title || "",
    isPublic: item?.isPublic === true,
    // Derived for display only; the Project owns the cover reference.
    isCover: coverImageId != null && item?.id != null && String(item.id) === String(coverImageId),
    displayOrder: Number.isInteger(item?.displayOrder) ? item.displayOrder : null,
    key: String(item?.id ?? "legacy-" + index),
  })).filter((item) => item.imageUrl);
  return images.map((item) => ({ ...item, isPublic: item.isCover || item.isPublic }));
}

const endpoint = (id) => "/admin/project/" + encodeURIComponent(id) + "/images";
export const projectMediaApi = {
  list: async (id) => {
    const { data } = await apiClient.get(endpoint(id));
    const images = Array.isArray(data) ? data : data?.images ?? data?.data;
    if (!Array.isArray(images)) throw new Error("The server returned an invalid image list.");
    return images;
  },
  listPublic: async (id) => {
    const { data } = await apiClient.get("/admin/project/" + encodeURIComponent(id) + "/public-images");
    if (!Array.isArray(data)) throw new Error("The server returned an invalid public image list.");
    return data;
  },
  setPublic: (id, imageIds, isPublic) => apiClient.patch(endpoint(id) + "/visibility", { imageIds, isPublic }),
  setCover: (id, imageId) => apiClient.put(endpoint(id) + "/cover", null, { params: { imageId } }),
  reorder: (id, imageIds) => apiClient.put(endpoint(id) + "/order", imageIds),
  remove: (id, imageId) => apiClient.delete(endpoint(id) + "/" + encodeURIComponent(imageId)),
  upload: (id, files, onUploadProgress) => {
    const body = new FormData();
    files.forEach((file) => body.append("files", file));
    body.append("isPublic", "false");
    return apiClient.post(endpoint(id), body, { headers: { "Content-Type": "multipart/form-data" }, onUploadProgress });
  },
};
